
export default function Features() {
  const features = [
    {
      title: "LMS機能あり-学習進捗を一元管理",
      description: ""
    },
    {
      title: "標準学習時間10時間以上-充実のコンテンツ量",
      description: ""
    },
    {
      title: "視聴履歴が残る-学習状況を詳細に把握",
      description: ""
    },
    {
      title: "終了証を取得できる-終了の証明証を発行",
      description: ""
    }
  ];

  return (
    <section id="features" className="py-20 bg-[#266fb7]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            LMS機能のご紹介
          </h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            当研修では、充実したLMS（学習管理システム）機能をご提供いたします。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 border border-gray-100 shadow-sm">
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-[#01a7ea] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-3 whitespace-pre-line">
                    {feature.title}
                  </h3>
                  {feature.description && (
                    <p className="text-gray-600 leading-relaxed">
                      {feature.description}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
